import { render } from "./NavigationButton.vue?vue&type=template&id=c80afb22&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=js"
export * from "./NavigationButton.vue?vue&type=script&lang=js"

import "./NavigationButton.vue?vue&type=style&index=0&id=c80afb22&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\studievalg-digital-tool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80afb22"]])

export default __exports__